import {RemoteCollectionStore, StoreBuilder} from '@softline/core';
import {WarenverprobungArtikelDetail} from '../data/warenverprobung-artikel-detail';

export const WarenverprobungArtikelDetailStore =
  new StoreBuilder(RemoteCollectionStore.create<WarenverprobungArtikelDetail>())
    .value
